import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { fetchApiAccessToken, readSessionToken, writeSessionToken } from "../utils/sessionAccessToken";

/**
 * Ensures `sessionStorage.token` is a real access token for `api()` Bearer auth.
 * Reuses a stored token when one is already present.
 * Otherwise fetches via Auth0 with the API audience, then provider defaults.
 * Returns false when no token could be stored — callers must not POST.
 */
export function useRefreshSessionToken() {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(async () => {
    if (readSessionToken()) {
      return true;
    }
    try {
      const token = await fetchApiAccessToken(getAccessTokenSilently);
      return writeSessionToken(token);
    } catch (e) {
      console.warn("[useRefreshSessionToken] getAccessTokenSilently failed:", e?.message || e);
      return false;
    }
  }, [getAccessTokenSilently]);
}
